import SectionSkeleton from "../../../../components/ui/SectionSkeleton"
import { Button, Typography } from "@mui/material"
import Images from "../../../../assets/js/Images"
import { Fragment, lazy, Suspense } from "react"

const TopBannerB = lazy(() => import("../../../../components/common/TopBannerB"))
const CtaSection = lazy(() => import("../../../../components/ui/CtaSection"))
const Testimonials = lazy(() => import("./Testimonials"))
const Workflow = lazy(() => import("./Workflow"))

function WellnessPlan() {
  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerB
          bannerImg={Images?.customWellness}
          headline="A Wellness Plan Designed Just for You"
          subHeadline="Take our assessment and get a plan tailored to your needs."
        >
          <Button
            variant="BannerButton"
          >Get My Custom Plan
          </Button>
        </TopBannerB>
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <Workflow />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <Testimonials />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <CtaSection>
          <Typography
            variant="ctaNormal"
          >Start Your Personalized Wellness Plan
          </Typography>
          <Button
            variant="CtaButton"
          >Start Now
          </Button>
        </CtaSection>
      </Suspense>
    </Fragment>
  )
}

export default WellnessPlan